module.exports = __webpack_public_path__ + "img/logo-white.40db2b9b.svg";